import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "../../environments/environment";
import { CronosProjectsPage } from "../cronos-projects/cronos-projects";

@IonicPage()
@Component({
  selector: "page-partner",
  templateUrl: "partner.html",
})
export class PartnerPage {
  public title: string;
  public url: any;
  public partner: string;
  public email: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public sanitizer: DomSanitizer
  ) {}

  ionViewDidLoad() {
    if (this.navParams.data) {
      this.partner = this.navParams.data.partner;
      this.email = this.navParams.data.email;
    }
    switch (this.partner) {
      case "gaap":
        this.title = "GAAP";
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
          environment.urlGaap
        );
        break;
      default:
        this.title = "Parceiro";
        this.url = "about:blank";
        break;
    }
  }

  backToHome() {
    this.navCtrl.setRoot(CronosProjectsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/partner/partner.ts